import React, { lazy } from 'react';
import PrivateRoute from 'PrivateRoutes';
// import { DNC } from './components';
const DNC = lazy (() => import(/* webpackChunkName: "DNC" */'./components'));
const routes = () => (
  <PrivateRoute exact path="/settings/DNC" component={DNC} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/DNC/routes.js